module.exports = __webpack_public_path__ + "img/logo.54e41337.png";